<template>
  <v-container fluid class="container_bg">

    <v-row justify="center" dense class="mt-5">
      <v-col cols="12" md="11">
        <h1>apiJewelItemList</h1>
      </v-col>
    </v-row>
    
    <v-divider/> 
    
    <v-row justify="center" dense class="mt-5">
      <v-col cols="12" md="11">
        <p>Jewelry subcategory Code Table.</p>
      </v-col>
    </v-row>

    <v-row justify="center" dense class="mt-5">
      <v-col cols="12" md="11">
        <h3>HTTP Request</h3>
      </v-col>
    </v-row>
    <v-row justify="center" dense>
      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">POST</v-col>
      <v-col cols="12" md="8" class="fielddesc">/apiJewelItemList</v-col>
    </v-row>
    
    <v-row justify="center" dense class="mt-5">
      <v-col cols="12" md="11">
        <h3>Request Body</h3>
        The request body contains data with the following structure.<br>Request Body is in the form x-www-form-urlencoded.
      </v-col>
    </v-row>
    
    <v-row justify="center" dense>
      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">PRODUCTTYPE_IDX</v-col>
      <v-col cols="12" md="8" class="fielddesc" align-center="center">Jewelry category index to be inquired <a @click="nav('apiJewelTypeList')">See APi for detailed code.</a></v-col>
    </v-row>
    
    <v-row justify="center" dense class="mt-5">
      <v-col cols="12" md="11">
        <h3>Response Body</h3>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="12" md="11" class="fieldname"><h4>JSON representation</h4></v-col>
      <v-col cols="12" md="11" class="fielddesc pa-0">
        <pre translate="no" style="background:#fafafa">
        {
          "resultCode": 0,
          "resultData": [
            {
              "PRODUCTITEM_IDX": 2,
              "PRODUCTTYPE_IDX": 1,
              "NAME_ENG": "Ring"
            }
            ...
        }          
        </pre>
      </v-col>
      
    </v-row>

    <v-row justify="center" dense class="mt-5 mb-10">
      <v-col cols="12" md="11" class="fieldname"><h4>Fields</h4></v-col>

      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">PRODUCTITEM_IDX</v-col>
      <v-col cols="12" md="8" class="fielddesc" align-center="center">
        Jewelry subcategory Index
      </v-col>
      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">PRODUCTITEM_IDX</v-col>
      <v-col cols="12" md="8" class="fielddesc" align-center="center">
        Jewelry Category Index
      </v-col>
      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">NAME_ENG</v-col>
      <v-col cols="12" md="8" class="fielddesc" align-center="center">
        English name for Jewelry subcategory
      </v-col>
    </v-row>


    <v-row justify="center" dense>
    </v-row>



  </v-container>
</template>
<script>

export default {

    mounted() {

    },

    data: () => ({

    }),

    methods: {

      nav(name){
        this.$router.push("/ApiDoc/"+name).catch(()=>{});
      },

    },

    created(){
      //apiProductList
    }


}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

table{
  width: 100%;
  border-collapse: collapse;
}
th, td {
  border: 1px solid #eaeaea;
  padding: 10px;
}
.fieldname {
  background: #f1f3f4;
  border: 1px solid #eaeaea;
}
.fielddesc {
  border: 1px solid #eaeaea;
  padding-left: 15px;
  padding-right: 15px;
}

</style>